import {PdfCatalogRepo} from "@app/core/pdf-catalog/domain/repositories/pdf-catalog.repo";
import {Product} from "@app/core/product/domain/dtos/product";
import {LargeStorageLocal} from "@app/core/shared/domain/storage/large-storage.local";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {BehaviorSubject, firstValueFrom, Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {PdfCatalogWebService} from "@app/core/pdf-catalog/infrastructure/pdf-catalog.web-service";

@Injectable({
    providedIn: "root",
})
export class PdfCatalogDataRepo implements PdfCatalogRepo {

    private storageKey = 'pdfProducts';
    private productsSubject = new BehaviorSubject<Product[]>([]);
    products$: Observable<Product[]> = this.productsSubject.asObservable();

    constructor(
        private localStorage: LargeStorageLocal,
        private apiUrls: ApiUrls,
        private deliveryPointLocal: DeliveryPointLocal,
        private  pdfCatalogWebService:PdfCatalogWebService
    ) {
        this.updateObservable();
    }


    addProduct(product: Product): void {
        let products = this.getProductsFromLocalStorage();

        if (products.find((productIn: { code: string; }) => product.code === productIn.code)) {
            return;
        }

        products.push(product)
        this.localStorage.setItem(this.storageKey, JSON.stringify(products))
        this.updateObservable();
    }

    getProducts(): Observable<Product[]> {
        return this.products$;
    }

    removeProduct(productCode: string): void {
        let product = this.getProductsFromLocalStorage() || [];
        const newProduct = product.filter(
            (productIn: { code: string; }) => productIn.code !== productCode
        );
        this.localStorage.setItem(this.storageKey, JSON.stringify(newProduct))
        this.updateObservable();
    }

    removeAllProduct(): void {
        this.localStorage.setItem(this.storageKey, JSON.stringify([]))
        this.updateObservable();
    }

    async getPdfApiUrl(showPrice: boolean) {
        const productRefs = this.productsSubject.value.map(product => product.code);
        const deliveryPointCode = await firstValueFrom(this.deliveryPointLocal.currentDeliveryPointCode$)
        return this.apiUrls?.PDF_CATALOG + deliveryPointCode + "/" + productRefs + "/" + showPrice;
    }

    private updateObservable() {
        this.productsSubject.next(this.getProductsFromLocalStorage())
    }

    private getProductsFromLocalStorage() {
        const productsString = this.localStorage.getItem(this.storageKey)
        if (productsString) {
            return JSON.parse(productsString);
        }
        return [];
    }

    downloadPdf(url: string): Observable<Blob> {
        return this.pdfCatalogWebService.execute(url);
    }
}
